function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import Shake from "/components/enhancements/shake/shake-component";
import Tooltip from "/components/enhancements/tooltip/tooltip-component";
import classnames from "classnames";
import onClickOutside from "react-onclickoutside";
import { withGenericConfig } from "/contexts/generic-config-context";
import { StyledWithErrorComponent } from "./input-error-handler.scss";
export default function withErrorHandler(WrappedComponent) {
    class WithErrorComponent extends PureComponent {
        renderErrorMessageIfNeeded() {
            const { preventErrorMessage, translate } = this.props;
            const { error } = this.state;
            const errorText = translate("signup.emailError");
            if (!error || preventErrorMessage) return;
            return /*#__PURE__*/ _jsx(Tooltip, {
                children: /*#__PURE__*/ _jsx("div", {
                    className: "error-tooltip-text",
                    children: errorText
                })
            });
        }
        render() {
            const { error, shouldShake } = this.state;
            return /*#__PURE__*/ _jsx(StyledWithErrorComponent, {
                className: classnames("error-handling-component"),
                children: /*#__PURE__*/ _jsxs(Shake, {
                    isActive: shouldShake,
                    children: [
                        /*#__PURE__*/ _jsx(WrappedComponent, _object_spread_props(_object_spread({}, this.props), {
                            isErrorState: error,
                            errorStateCallback: this.updateErrorState
                        })),
                        this.renderErrorMessageIfNeeded()
                    ]
                })
            });
        }
        constructor(props){
            super(props);
            _define_property(this, "handleClickOutside", ()=>{
                this.setState({
                    error: false,
                    shouldShake: false
                });
            });
            _define_property(this, "resetShaker", ()=>{
                if (this.state.shouldShake) {
                    setTimeout(()=>this.setState({
                            shouldShake: false
                        }), 600);
                }
            });
            _define_property(this, "updateErrorState", (error)=>{
                this.setState({
                    error: error,
                    shouldShake: error
                }, this.resetShaker);
            });
            this.state = {
                error: false,
                shouldShake: false
            };
        }
    }
    return withGenericConfig(onClickOutside(WithErrorComponent));
}
